import React, { FunctionComponent } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import List from "../../List";
import VideoPreview from "../../VideoPreview";
import { InternalLinkIcon } from "../../Icons";
import {
  PagePath,
  SanityImage,
  SanitySlug,
  SanityTeaser,
} from "../../../types/common";
import { formatLink } from "../../../utils/formatLink";

import "./styles.scss";

type ExtraContentVideosListProps = {
  data: {
    title?: string | null;
    description?: string | null;
    cta?: string | null;
    videos: {
      _id: string;
      _createdAt: string;
      title: string;
      _rawDescription: any;
      slug: SanitySlug;
      image: SanityImage;
      teaser?: SanityTeaser | null;
    }[];
  };
};

type QueryData = {
  allSanityVideoLandingPage: {
    nodes: PagePath[];
  };
};

const ExtraContentVideosList: FunctionComponent<
  ExtraContentVideosListProps
> = ({ data }) => {
  const query = useStaticQuery<QueryData>(graphql`
    {
      allSanityVideoLandingPage {
        nodes {
          _id
          parentPage {
            slug {
              current
            }
          }
          slug {
            current
          }
        }
      }
    }
  `);

  const videosPage = query.allSanityVideoLandingPage.nodes[0];

  return (
    <section className="extra-content-videos-list ivory">
      <div>
        <div className="extra-content-videos-list-header">
          <div>
            <h2>{data.title ? data.title : "Videos"}</h2>
            {data.description && <p>{data.description}</p>}
          </div>
          <Link to={formatLink(videosPage)}>
            <span>Discover more videos</span>
            <InternalLinkIcon />
          </Link>
        </div>

        <div className="extra-content-videos-list-container">
          <List
            singularLabel="video"
            pluralLabel="videos"
            items={data.videos.map((video) => (
              <VideoPreview key={video._id} video={video} />
            ))}
          />
        </div>
      </div>
    </section>
  );
};

export default ExtraContentVideosList;
